export default function flattenTree(tree, options = {}, indent = 0) {
  let { childrenKey = "items", indentKey = "indent" } = options;
  let items = [];
  tree.forEach((item) => {
    items.push({ ...item, [indentKey]: indent });
    if (item[childrenKey]) {
      items = items.concat(flattenTree(item[childrenKey], options, indent + 1));
    }
  });
  return items;
}
